import 'bootstrap/dist/css/bootstrap.min.css';
import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import AuthService from "../services/authService"; // Replace with your actual service
import PersonnelService from '../services/personnelService';

const Sign = () => {
    const navigate = useNavigate();
    const [nom, setNom] = useState('');
    const [motDePasse, setMotDePasse] = useState('');
    const [verifMotDePasse, setVerifMotDePasse] = useState('');
    const [poste, setPoste] = useState('');
    const [updating, setUpdating] = useState(false);
    const [passwordMatch, setPasswordMatch] = useState(null); 
    const [errorMessage, setErrorMessage] = useState('');
    const [personnels, setPersonnels] = useState([]);

    const update = async () => {
        if (motDePasse !== verifMotDePasse) {
            setPasswordMatch(false);
            setErrorMessage("Les mots de passe ne correspondent pas.");
            return;
        }

        setUpdating(true);
        const selectedPersonnel = personnels.find(person => person.code === poste);
        const userId = selectedPersonnel ? selectedPersonnel.id : null;

        if (userId) {
            const response = await AuthService.updateAccount(userId, nom, motDePasse, poste);
            if (response.success) {
                navigate('/login');
            } else {
                setErrorMessage(response.error);
            }
        } else {
            setErrorMessage("Utilisateur non trouvé.");
        }

        setUpdating(false);
    }

    const handlePasswordChange = (event) => {
        setMotDePasse(event.target.value);
        if (verifMotDePasse && event.target.value !== verifMotDePasse) {
            setPasswordMatch(false);
        } else {
            setPasswordMatch(true);
        }
    }

    const handleVerifPasswordChange = (event) => {
        setVerifMotDePasse(event.target.value);
        if (motDePasse && event.target.value !== motDePasse) {
            setPasswordMatch(false);
        } else {
            setPasswordMatch(true);
        }
    }

    useEffect(() => {
        PersonnelService.pass()
        .then(result => {
          if (result.success) {
            setPersonnels(result.data);
          }
        })
        .catch(error => alert(error.error));
    }, []);

    return (
        <div className="container d-flex align-items-center justify-content-center" style={{ minHeight: "80vh" }}>
            <div className="card p-4" style={{ maxWidth: "400px", width: "100%", height: "600px" }}>
                <h1 className="card-title text-center mb-4">Modifier le compte</h1>

                <label htmlFor="nom">Nom</label>
                <input
                    type="text"
                    className="form-control mb-3"
                    onChange={(event) => setNom(event.target.value)}
                    value={nom}
                    placeholder="Nom"
                    id="nom"
                />
                <label htmlFor="pass">Mot de passe</label>
                <input
                    type="password"
                    className={`form-control mb-3 ${passwordMatch === false ? 'is-invalid' : ''} ${passwordMatch === true ? 'is-valid' : ''}`}
                    onChange={handlePasswordChange}
                    value={motDePasse}
                    placeholder="Mot de passe"
                    id="pass"
                />
                <label htmlFor="verifPass">Vérifiez le mot de passe</label>
                <input
                    type="password"
                    className={`form-control mb-3 ${passwordMatch === false ? 'is-invalid' : ''} ${passwordMatch === true ? 'is-valid' : ''}`}
                    onChange={handleVerifPasswordChange}
                    value={verifMotDePasse}
                    placeholder="Vérifiez le mot de passe"
                    id="verifPass"
                />
                {passwordMatch === false && (
                    <div className="invalid-feedback">
                        {errorMessage}
                    </div>
                )}
                <label htmlFor="poste">Poste</label>
                <select
                    className="form-control mb-3"
                    onChange={(event) => setPoste(event.target.value)}
                    value={poste}
                    id="poste"
                >
                    {personnels.map((person, index) =>
                        <option key={index} value={person.code}>{person.code}</option>
                    )}
                    
                </select>
                <button className="btn btn-primary btn-block" onClick={update} disabled={updating}>
                    {updating ? "Mise à jour en cours..." : "Mettre à jour"}
                </button>
                <br />
                <p style={{color:"blue", textDecoration:'underline'}}>
                    <Link to={"/login"}>Déjà un compte? Se connecter</Link>
                </p>
            </div>
        </div>
    );
}

export default Sign;
